"use client";

import { motion } from "framer-motion";

import styles from "../styles";
import { fadeIn, staggerContainer } from "../utils/motion";
import { PartnerData } from "../constants";

export const ConfidentlyCard = ({
  key,
  id,
  title,
  index,
  paragraph,
  bg,
  text,
  icon,
}) => {
  return (
    <motion.div
      variants={fadeIn("right", "spring", index * 0.5, 0.75)}
      key={key}
      className={`w-full p-5 flex flex-col space-y-6 items-start  justify-start bg-white rounded-10px `}>
      <div className={`p-3 flex items-center justify-center`}>
        <img src={icon} alt={title} className="w-12 h-12" />
      </div>
      <div className="w-full text-left  items-start justify-start space-y-4 ">
        <h1 className="text-base w-3/4 xl:text-[20px] font-medium text-black leading-6 ">
          {title}
        </h1>
        <p className="w-3/4 text-sm  text-gray-500">{paragraph}</p>

      </div>
    </motion.div>
  );
};

const Confidently = () => (
  <section className={`${styles.paddings} relative z-10 bg-[#F2F8FD]`}>
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto grid grid-cols-1 lg:grid-cols-3 gap-5`}>
      {PartnerData.map((world, index) => (
        <ConfidentlyCard key={world.id} {...world} index={index} />
      ))}
    </motion.div>
  </section>
);

export default Confidently;
